import {
    inAppMenu,
    manageYourTeam,
} from '@weirgroup/cde-iam-accessmanagement-app'
import { combineReducers } from 'redux'
import assetReducer from './assetReducer'

const appReducer = combineReducers({
    manageYourTeam,
    inAppMenu,
    asset: assetReducer
})

const rootReducer = (state, action) => appReducer(state, action)

export default rootReducer
